import { render, staticRenderFns } from "./Refrigerators_custom_01.vue?vue&type=template&id=e664dd46&scoped=true&"
import script from "./Refrigerators_custom_01.vue?vue&type=script&lang=js&"
export * from "./Refrigerators_custom_01.vue?vue&type=script&lang=js&"
import style0 from "./Refrigerators_custom_01.vue?vue&type=style&index=0&id=e664dd46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e664dd46",
  null
  
)

component.options.__file = "Refrigerators_custom_01.vue"
export default component.exports